<script context="module" lang="ts">
  enum Sizes {
    Large = 'large',
    Medium = 'medium',
    Small = 'small'
  }

  enum Style {
    Primary = 'primary',
    Secondar = 'secondary',
    Link = 'link',
    NoLink = 'no-link'
  }

  enum SpinnerSize {
    Small = '16px',
    Medium = '18px',
    Large = '20px'
  }

  enum Types {
    Button = 'button',
    Submit = 'submit'
  }

  export const ButtonSizes = Sizes;
  export const ButtonStyle = Style;
  export const ButtonTypes = Types;
</script>

<script lang="ts">
  import Spinner from '$shared/atoms/Spinner/Spinner.svelte';
  import Icon from '$shared/atoms/Icon/Icon.svelte';

  export let disabled = false;
  export let loading = false;
  export let size: Sizes | string = '';
  export let style: Style | string = Style.Secondar;
  export let type: Types | string = Types.Button;
  export let maxWidth = false;
  export let active = false;
  export let icon = '';
  export let tabIndex = 1;
  export let name = '';

  let spinnerSize: SpinnerSize = SpinnerSize.Small;

  $: isSpinnerLightTheme = style === Style.Primary;
  $: {
    if (size === Sizes.Large) {
      spinnerSize = SpinnerSize.Large;
    } else if (size === Sizes.Small) {
      spinnerSize = SpinnerSize.Small;
    }
  }

  let iconProps: ObjectType<string> = {};
  $: {
    // Color
    let color = '';
    if (active) {
      color = 'active';
    }
    if (style === Style.Primary || disabled) {
      color = 'white';
    }

    // Size
    let fontSize = '14px';
    let size = '14px';
    if (size === Sizes.Small) {
      fontSize = '12px';
      size = '12px';
    }
    iconProps = {
      value: `${icon} ${color}`,
      fontSize,
      size
    };
  }
</script>

<button
  {type}
  class="comp-button {size} {style}"
  data-cy={name}
  class:loading
  class:maxWidth
  class:active
  {disabled}
  {tabIndex}
  on:click|stopPropagation|preventDefault
>
  {#if loading}
    <Spinner light={isSpinnerLightTheme} size={spinnerSize} />
  {:else}
    {#if icon}
      <div class="icon">
        <Icon {...iconProps} />
      </div>
    {/if}
    <slot />
  {/if}
</button>

<style src="./Button.css">
</style>
